import { useState } from 'react'
import { useLingui } from '@lingui/react/macro'
import * as Dialog from '@radix-ui/react-dialog'

import { DialogHeader, dialogContainer } from '@/layouts/Dialog'
import { AddButton } from '@/components/ui/IconButton'
import { GuestForm } from './GuestForm'

type CreateProps = {
  search: string
  onDone: () => void
  onCancel: () => void
}

function CreateGuestContent({ search, onDone, onCancel }: CreateProps) {
  const { t } = useLingui()

  return (
    <div
      className="flex flex-col gap-5"
      // We catch the inner submit, so that we only submit the Guest creation and not the surrounding Form, for example Stay
      onSubmit={event => event.stopPropagation()}
    >
      <DialogHeader
        title={t`Create Guest`}
        description={t`Create a new guest to add them to a stay.`}
        close={onCancel}
      />
      <GuestForm onDone={onDone} defaultName={search} />
    </div>
  )
}

export default function CreateGuestButton({ search }: { search: string }) {
  const { t } = useLingui()
  const [open, setOpen] = useState(false)

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <AddButton aria-label={t`Create new guest`} />
      </Dialog.Trigger>
      <Dialog.Portal container={dialogContainer}>
        <Dialog.Overlay className="fixed size-full inset-0 bg-black/30 grid place-items-center overflow-y-auto z-top-dialog">
          <Dialog.Content className="relative w-screen max-w-[500px] py-10 px-2">
            <div className="shadow-md rounded bg-white flex flex-col gap-4 p-5">
              <CreateGuestContent
                onDone={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                search={search}
              />
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
